import styles from './FooterLegalLinks.scss';

import cx from 'classnames';
import React, { FC, HTMLAttributes } from 'react';

import { ExternalLink, InternalLink } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLinkV2 } from 'src/components/ContentLinkV2/ContentLinkV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';

export interface FooterLegalLinksProps extends HTMLAttributes<HTMLDivElement> {
  items?: Array<FlatEntry<ExternalLink | InternalLink>>;
  isList?: boolean;
}

const copyrightText = `\u00A9 ${new Date().getFullYear()} Clover Network, Inc. `;

export const FooterLegalLinks: FC<FooterLegalLinksProps> = ({
  items = [],
  className,
  isList = false,
  ...props
}) => (
  isList ? (
    <ul>
      <li>{copyrightText}</li>
      {items.map((item, index) => item.title && (
        <li key={componentKeyV2(item, index)}><ContentLinkV2 entry={item} /></li>
      ))}
    </ul>
  ) : (
    <div className={cx(styles.footerLegalLinks, className)} {...props}>
      <span>{copyrightText}</span>
      {items.map((item, index) => item.title && (
        <ContentLinkV2 key={componentKeyV2(item, index)} entry={item} className={styles.link} />
      ))}
    </div>
  )
);

FooterLegalLinks.displayName = 'FooterLegalLinks';
